import request from '@/utils/request'

const logs = {
  name: 'logs',
  state: {
    isLogsDetailLoading: false,
    logsDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_LOGS_DETAIL_LOADING: (state, data) => {
      state.isLogsDetailLoading = data
    },
    SET_MODULES_LOGS_DETAIL_DATA: (state, data) => {
      state.logsDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryLogsDetailData({ commit }, id) {
      commit('SET_IS_MODULES_LOGS_DETAIL_LOADING', true)
      commit('SET_MODULES_LOGS_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/logs/logsDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_LOGS_DETAIL_LOADING', false)
          commit('SET_MODULES_LOGS_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_LOGS_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetLogsDetailData({ commit }) {
      commit('SET_MODULES_LOGS_DETAIL_DATA', {})
    }
  }
}

export default logs
